export default __webpack_public_path__ + "static/media/BannerTablet.81516d90.jpg";